import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,Stack, FormControl, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next';

function AddNewValue(props) {
    const { openModal, toggle } = props;
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const [description, setDescription] = useState('');

    const handleCancelClick = () => toggle();

    const handleClick = () => {
        if (props.action === 'MODIFY') props.handleModify({ID: props.row.ID , VALUE: value, DESCRIPTION: description});
        else props.handleInput({ VALUE: value, DESCRIPTION: description });
    }

    useEffect(() => {
        setValue(props?.row?.VALUE || '');
        setDescription(props?.row?.DESCRIPTION || '');
    }, [openModal]);

    return (
        <>
            <Dialog open={openModal} maxWidth='md'>
                <DialogTitle className='dialog-header'>
                    <div className='title'>
                        {t('DIAG_NEW_DATA_VALIDATION_CONTAINS_VALUE_TIT')}
                    </div>
                </DialogTitle>
                <DialogContent className='modal-content' dividers>
                    <p className='title'>
                        {t('DIAG_NEW_DATA_VALIDATION_CONTAINS_VALUE_DESC')}
                    </p>
                    <Stack spacing={"20px"} className="tp-segment">
                        <FormControl className="width-100" size="small">
                            <TextField
                                variant='outlined'
                                size='small'
                                type='text'
                                autoFocus={true}
                                label={t('LBL_VALUE')}
                                className={'width-100'}
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                            />
                        </FormControl>
                        <FormControl className="width-100" size="small">
                            <TextField
                                variant='outlined'
                                size='small'
                                type='text'
                                label={t('LBL_DESC')}
                                className={'width-100'}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </FormControl>
                    </Stack>
                     
                </DialogContent>
                <DialogActions>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={handleClick}
                    >
                        {t("BTN_OK")}
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={handleCancelClick}
                    >
                        {t("BTN_CANCEL")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AddNewValue